// IframeComponent.tsx
import React from "react";

export default function IframeComponent() {
  const baseUrl = "http://localhost:3000/player-wall";
  const ids = [1, 2, 3, 4];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-screen h-screen p-2">
      {ids.map((id) => (
        <div
          key={id}
          className="relative h-full rounded-2xl overflow-hidden border shadow-sm"
        >
          <iframe
            title={`player-wall-${id}`}
            src={`${baseUrl}?id=${id}`}
            className="absolute inset-0 w-full h-full"
            loading="lazy"
            allowFullScreen
            // نکته: در React باید از frameBorder با camelCase استفاده کنید
            frameBorder={0}
            referrerPolicy="no-referrer"
          />
        </div>
      ))}
    </div>
  );
}
